"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M10 2H6V0h4v2zM0 6v4h2V6H0zm6 10h4v-2H6v2zm8-6V6h2v4h-2zM2 0H1a1 1 0 00-1 1v3h2V2h2V0H2zM0 15v-3h2v2h2v2H1a1 1 0 01-1-1zm14 1h1a1 1 0 001-1v-3h-2v2h-2v2h2zm2-15v3h-2V2h-2V0h3a1 1 0 011 1z"];
//# sourceMappingURL=selection-box.js.map